import { api } from "./backend";
import { procesarFiltros } from "./listado";

export function tablaAnalisisPorModulos(filtros) {
  const procesados = procesarFiltros(filtros);
  return api.post("productividadComercial/tablaAnalisisPorModulos", { filtros: procesados }).then((r) => r.data);
}
